function FormSkeleton() {
  return (
    <div className="bg-white rounded shadow-sm w-full p-6 mx-auto">
      {/* Header */}
      <div className="flex items-center mb-5">
        <div className="h-6 w-36 bg-gray-200 rounded animate-pulse" />
      </div>
      {/* Top Row: Category Name, Slug, Is Parent */}
        <div className="flex flex-wrap gap-4 mb-4">
            {/* Category Name */}
            <div className="flex-1 min-w-[220px]">
            <div className="h-4 w-28 bg-gray-100 rounded mb-1 animate-pulse" />
            <div className="h-10 w-full bg-gray-100 rounded animate-pulse" />
            </div>
            {/* Slug */}
            <div className="flex-1 min-w-[220px]">
            <div className="h-4 w-16 bg-gray-100 rounded mb-1 animate-pulse" />
            <div className="h-10 w-full bg-gray-100 rounded animate-pulse" />
            </div>
            <div className="flex-1 min-w-[220px]">
            <div className="h-4 w-16 bg-gray-100 rounded mb-1 animate-pulse" />
            <div className="h-10 w-full bg-gray-100 rounded animate-pulse" />
            </div>
        </div>
      
      {/* Description */}
      <div className="mb-8">
        <div className="h-4 w-24 bg-gray-100 rounded mb-1 animate-pulse" />
        <div className="h-12 w-full bg-gray-100 rounded animate-pulse" />
      </div>
      {/* Footer Buttons */}
      <div className="flex justify-end gap-3 mt-2">
        <div className="h-10 w-24 bg-gray-200 rounded animate-pulse" />
        <div className="h-10 w-32 bg-gray-200 rounded animate-pulse" />
      </div>
    </div>
   
  );
}
export default FormSkeleton;
